module.exports = __webpack_public_path__ + "img/Circinus.e6a91f00.png";